module.exports = __webpack_public_path__ + "img/2021cp02_bnr.6acbd02e.jpg";